import React from 'react';
import { useContact } from '../hooks/useContact';
import ClientServiceContext from './context';
import { useSchema } from '../hooks/useSchema';
import { useEditCustomer } from '../hooks/useEditCustomer';

const ClientServiceProvider = (options) => {
    const {
        options: {
            contactId,
        },
        children,
    } = options;
    const contact = useContact({ contactId });
    const schema = useSchema({ loadInitially: true });
    const editCustomer = useEditCustomer();

    const state = {
        contactId, contact, schema, editCustomer,
    };
    const getValue = (callback) => callback(state);

    return (
        <ClientServiceContext.Provider
            value={{ ...state, getValue }}
        >
            {children}
        </ClientServiceContext.Provider>
    );
};

export default ClientServiceProvider;
